/* eslint-disable max-len */
import { getBlackList } from '@bingads-webui-campaign/import-shared-repositories';
import { getImportOptionFields as getDefaultImportOptionFields } from './index';

export const getSubFieldsBlackList = (permissions) => {
  const subFieldsBlacklist = getBlackList(permissions);

  // filter out some options for P0 requirement
  subFieldsBlacklist.push('ImportAccountUrlOptions');
  subFieldsBlacklist.push('ImportDeletedEntities');
  subFieldsBlacklist.push('ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBids');
  subFieldsBlacklist.push('ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBidStrategies');
  subFieldsBlacklist.push('ImportUpdateEntityPreference_UpdateCampaignBudget');
  subFieldsBlacklist.push('RaiseLowBidsToMinServingBidsForBsc');
  subFieldsBlacklist.push('AutoDeviceBidOptimization');
  // other options
  subFieldsBlacklist.push('ImportAppendDestUrlPreference_UseAppendString');
  subFieldsBlacklist.push('ImportAppendDestUrlPreference_AppendStringForDestinationUrl');
  // subFieldsBlacklist.push('ImportSearchAndReplaceDestUrlPreference_UseSearchAndReplaceString');
  // subFieldsBlacklist.push('ImportSearchAndReplaceDestUrlPreference_SearchStringForDestinationUrl');
  // subFieldsBlacklist.push('ImportSearchAndReplaceDestUrlPreference_ReplaceStringForDestinationUrl');
  subFieldsBlacklist.push('AppendPreferencesForTrackingTemplate_UseAppendString');
  subFieldsBlacklist.push('AppendPreferencesForTrackingTemplate_AppendStringForTrackingTemplate');
  subFieldsBlacklist.push('SearchAndReplacePreferencesForTrackingTemplate_UseSearchAndReplaceString');
  subFieldsBlacklist.push('SearchAndReplacePreferencesForTrackingTemplate_SearchStringForTrackingTemplate');
  subFieldsBlacklist.push('SearchAndReplacePreferencesForTrackingTemplate_ReplaceStringForTrackingTemplate');
  subFieldsBlacklist.push('SearchAndReplaceForCustomParameters_EnableSearchAndReplace');
  subFieldsBlacklist.push('SearchAndReplaceForCustomParameters_SearchString');
  subFieldsBlacklist.push('SearchAndReplaceForCustomParameters_ReplaceString');
  subFieldsBlacklist.push('SearchAndReplaceForFinalURLSuffix_EnableSearchAndReplace');
  subFieldsBlacklist.push('SearchAndReplaceForFinalURLSuffix_SearchString');
  subFieldsBlacklist.push('SearchAndReplaceForFinalURLSuffix_ReplaceString');
  subFieldsBlacklist.push('ImportUpdateEntityPreference_UpdateNameForExistingCampaigns');
  subFieldsBlacklist.push('ImportNewOption_ImportNewCampaignsAndMarkAsPaused');
  // subFieldsBlacklist.push('ImportNewOption_ImportNewActiveEntitiesOnly');
  subFieldsBlacklist.push('ImportSearchAndDsaMixedCampaignAsSearchCampaign');
  subFieldsBlacklist.push('ImportPrefixAndSuffixForStringProperty_EnablePrefixAndSuffix');
  subFieldsBlacklist.push('ImportPrefixAndSuffixForStringProperty_SuffixString');
  subFieldsBlacklist.push('ImportSearchAndReplaceForStringProperty_EnableSearchAndReplace');
  subFieldsBlacklist.push('ImportSearchAndReplaceForStringProperty_SearchString');
  subFieldsBlacklist.push('ImportSearchAndReplaceForStringProperty_ReplaceString');
  subFieldsBlacklist.push('ImportNewOption_ImportAllAdUnderAnAdGroup');
  subFieldsBlacklist.push('PauseParentIfNoLocationSupported');
  subFieldsBlacklist.push('EnableParentLocationMapping');
  subFieldsBlacklist.push('StoreIdForImportedProductAdExtensionsFlag');
  subFieldsBlacklist.push('StoreIdForImportedProductAdExtensions');
  subFieldsBlacklist.push('StoreIdForImportedProductAdExtensions');
  subFieldsBlacklist.push('AutoDeviceBidOptimization');
  subFieldsBlacklist.push('PauseAIMAdGroupIfAllAudienceCriterionNotImported');
  subFieldsBlacklist.push('ImportNewOption_ImportNewImageAdExtensions');
  subFieldsBlacklist.push('ImportUpdateEntityPreference_UpdateImageAdExtensions');
  subFieldsBlacklist.push('RenameCampaignNameWithSuffix');

  return subFieldsBlacklist;
};

export const importOptionFieldHelpIds = {
  ImportNewEntities: 'Pop_BA_Import_FB_ItemsNotPreviouslyImported',
  UpdateEntityPreferences: 'Pop_BA_Import_FB_UpdateExistingItems',
  DefaultBidsBelowMinToAdCenterMinBid: 'pop_BA_Import_FB_SetUnknownBid',
  DefaultCampaignBudgetBelowMinToAdCenterMinBudget: 'pop_BA_Import_FB_IncreaseCampBudget',
  AdjustmentForBids_EnableAdjustment: 'Pop_BA_Import_FB_AdjustBidValue',
  AdjustmentForCampaignBudgets_EnableAdjustment: 'Pop_BA_Import_FB_AdjustBudgValue',
  ImportNewOption_ImportNewActiveEntitiesOnly: 'pop_BA_Import_FB_PauseCampaigns',
};

export const getImportOptionFields = (params) => {
  const optionFields = getDefaultImportOptionFields({
    ...params,
    hideEntityAdvancedOptions: true,
    helpIds: importOptionFieldHelpIds,
    isPauseAdGroupIfNoLocationSupportedEnabled: true,
    isAudienceTargetForFBImportOptionEnabled: true,
  });
  return optionFields;
};
